import { Fragment, useEffect, useState } from "react";

import { Dialog, Switch, Transition } from "@headlessui/react";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import card from "../../assets/images/icon_card/card.svg";
import settingBlackIcon from "../../assets/images/icon_card/setting-black.svg";
import settingIcon from "../../assets/images/icon_card/setting.svg";
import syncHistory from "../../assets/images/icon_card/sync.svg";
import tkiWhite from "../../assets/images/icon_card/tki-white.svg";
import Config from "../../config/Config";
import { formatCurrency } from "../../config/global";
import { useAppSelector } from "../../core/feature/hooks";
import {} from "../../core/feature/store";
import CustomApp from "../../core/models/customApp";
import User from "../../core/models/user";
import * as api_card from "../../core/service/api_card";
import { StatsInvoice } from "../common/home/Stats";

import { Swiper, SwiperSlide } from "swiper/react";

// import required modules
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import moment from "moment";
import CurrencyInput from "react-currency-input-field";
import { useTranslation } from "react-i18next";
import { EffectCoverflow, Keyboard, Navigation } from "swiper";
import { isDarkColor } from "../../config/DarkColorChecker";
import { BackButton } from "../common/BackButton";

const PickupStudentWeb = (props: any) => {
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const user: User = useAppSelector((state) => state.user.user);
  const token: String = useAppSelector((state) => state.token.token);
  const [pages, setPage] = useState(0);
  let companyStorage = JSON.parse(String(localStorage.getItem("company")));
  const [lastPage, setLastPage] = useState(0);
  const [data, setData] = useState<any>([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [position, setPosition] = useState(0);
  const [cards, setCards] = useState<any>([]);
  const [selectedCard, setSelectedCard] = useState<any>({});
  const [tempDaily, setTempDaily] = useState("");
  const [daily, setDaily] = useState(0);
  const [tempLimitMax, setTempLimitMax] = useState("");
  const [limitMax, setLimitMax] = useState(0);
  const [tempCardBalance, setTempCardBalance] = useState("");
  const [cardBalance, setCardBalance] = useState(0);
  const [isUnlimited, setIsUnlimited] = useState(false);
  const [isUnlimited2, setIsUnlimited2] = useState(false);
  const [currentUnlimited, setCurrentUnlimited] = useState(false);
  const [currentUser, setCurrentUser] = useState<any>({});
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  let [isOpen, setIsOpen] = useState(false);
  let [noData, setNoData] = useState(false);
  const [tags, setTags] = useState<any>([]);
  const [selectedTags, setSelectedTags] = useState<any>([]);
  const { t } = useTranslation();
  const cardData = JSON.parse(String(localStorage.getItem("card")));
  const env = Config.BaseUrlDev;

  useEffect(() => {
    if (user == undefined) {
      navigate("/login", { replace: true });
    } else {
      // console.log(companyStorage.cardSetting.limitChange, "ini kompany")
      getUserData();
      getAllCard();
      getUnlimited();
    }
  }, []);
  useEffect(() => {
    console.log("tes", location.pathname.split("/")[2]);
    if (location.pathname.split("/")[2] != undefined) {
    }
  }, [location.pathname.split("/")[2]]);

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  function getAllCard() {
    api_card.getCards().then((res: any) => {
      console.log(res.data.length);
      if (res.data.length > 0) {
        if (!localStorage.getItem("card")) {
          localStorage.setItem("card", JSON.stringify(res.data));
        }
        let temp = cards.concat(res.data);
        setCards(temp);

        setSelectedCard(temp[0]);
        setLimitMax(temp[0].limitMax);
        setDaily(temp[0].limitDaily);
        setCardBalance(temp[0].cardBalance);

        setTempLimitMax(getCurrency(temp[0].limitMax));
        setTempDaily(getCurrency(temp[0].limitDaily));
        setTempCardBalance(getCurrency(temp[0].cardBalance));
      }
    });
  }

  function getUserData() {
    api_card
      .getUser()
      .then((res) => {
        let tempUser = {
          active: res.data.accounts[0].active,
          address: res.data.address,
          banks: res.data.banks,
          callerId: "",
          callerName: "",
          callerTitle: "",
          dateOfBirth: res.data.dateOfBirth,
          email: res.data.email,
          gender: res.data.gender,
          maritalStatus: res.data.maritalStatus,
          name: res.data.name,
          nik: res.data.name,
          note: res.data.note,
          phone: res.data.phone,
          photoUrl: res.data.photoUrl,
          placeOfBirth: res.data.placeOfBirth,
          religion: res.data.religon,
          roles: res.data.accounts[0].roles,
          socmedAccounts: res.data.sosmedAccounts,
          sourceOfFund: res.data.accounts[0].sourceOfFund,
          tags: [],
          transactionUnlimited: res.data.accounts[0].transactionUnlimited,
        };
        console.log(res.data);
        let temp = res.data.accounts[0].transactionUnlimited;
        setCurrentUnlimited(temp);
        setIsUnlimited(temp);
        setIsUnlimited2(temp);
        setCurrentUser(tempUser);
      })
      .catch((er) => {
        navigate("/login", { replace: true });
      });
  }

  function saveData() {
    let unlimitedChanged = isUnlimited != currentUnlimited;
    let limitChanged =
      selectedCard.cardBalance != cardBalance ||
      selectedCard.limitMax != limitMax ||
      selectedCard.limitDaily != daily;

    if (unlimitedChanged) {
      let temp = currentUser;
      temp.transactionUnlimited = isUnlimited;
      api_card
        .saveUnlimited(temp)
        .then((res: any) => {
          closeModal();
          getUserData();
        })
        .catch((e) => {
          closeModal();
        });
    }

    if (limitChanged) {
      let temp = selectedCard;
      temp.cardBalance = cardBalance;
      temp.limitMax = limitMax;
      temp.limitDaily = daily;
      api_card
        .saveCard(temp.id, temp)
        .then((res: any) => {})
        .catch((e) => {});
    }
    // var studentCard = _.find(cardData, { id: selectedCard.id });
    // var studentCardIndex = _.findIndex(cardData, { id: selectedCard.id });
    // studentCard.dateSync = moment().format("LLL");
    if (unlimitedChanged || limitChanged) {
      var studentCard = _.find(cardData, { id: selectedCard.id });
      console.log(cardData, selectedCard.id);

      var studentCardIndex = _.findIndex(cardData, { id: selectedCard.id });
      var dateSync = [];
      dateSync = studentCard?.dateSync || [];
      dateSync.push(moment().format("YYYY-MM-DD HH:mm"));
      studentCard.dateSync = dateSync;

      _.replace(cardData, cardData[studentCardIndex], studentCard);
      localStorage.setItem("card", JSON.stringify(cardData));
    }

    closeModal();
  }

  function getUnlimited() {
    let temp = JSON.parse(String(localStorage.getItem("user_redux")))
      .accounts[0].transactionUnlimited;
    setIsUnlimited(temp);
  }

  function goToSync() {
    navigate(`/digital-card/${cards[position].id}`);
  }

  function closeModal() {
    setIsOpen(false);
    setIsUnlimited(isUnlimited2);
  }

  function openModal() {
    setLimitMax(cards[position].limitMax);
    setDaily(cards[position].limitDaily);
    setCardBalance(cards[position].cardBalance);

    setIsOpen(true);
  }
  const [help, setHelp] = useState(false);

  function onPositionChange(currentPosition: any) {
    if (currentPosition != position) {
      setPosition(currentPosition);
      setSelectedCard(cards[currentPosition]);

      setCardBalance(cards[currentPosition].cardBalance);
      setLimitMax(cards[currentPosition].limitMax);
      setDaily(cards[currentPosition].limitDaily);
    }
    console.log(selectedCard);
  }

  function getLastSync(id: any) {
    var studentCard = _.find(cardData, { id: id });
    console.log(
      moment(studentCard?.dateSync).format("DD-MMMM-YYYY hh:mm"),
      "dfdfkdk"
    );
    if (
      Array.isArray(studentCard?.dateSync) &&
      studentCard.dateSync.length > 0
    ) {
      return studentCard.dateSync[studentCard.dateSync.length - 1];
    } else {
      return "";
    }
  }

  function numberOnly(str: any) {
    return String(str).replace(/[^0-9.]/g, "");
  }

  function getCurrency(str: any) {
    return formatCurrency(str).replace(",00", "");
  }
  return (
    <div className="bg-psp-primary mb-8 font-montserrat">
      <StatsInvoice />
      <div className="h-auto flex bg-psp-primary mt-10">
        <div className="mx-none  container h-full flex-row flex justify-between relative mb-16">
          <div className="flex flex-col rounded-2xl -top-36 relative bg-white items-center py-2 px-8  w-full my-2 mx-1">
            <div className="flex py-2 px-2 w-full relative flex-col bg-white mb-8 ">
              <div className="flex mb-4">
                <BackButton />
                <div className="font-bold text-4xl">
                  {t("PICKUPSTUDENT.title")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PickupStudentWeb;
